<template>
  <!--
    ORDEN estructural: en Vuetify 2 el prop `app` izaba la barra y el drawer al
    registro de layout desde cualquier lugar del DOM. Desde V3 el layout es
    puramente posicional: <v-app-bar> y <v-navigation-drawer> tienen que ser
    HERMANOS ANTERIORES a <v-main>. Con la estructura anterior —donde ambos
    vivían DENTRO de <v-main>— los drawers renderizaban en el flujo de la página.
  -->
  <ag-app-bar />
  <ag-nav-drawer />
  <v-main>
    <router-view :key="route.fullPath" />
  </v-main>
</template>

<script setup lang="ts">
import { useRoute } from "vue-router";
import AgAppBar from "@/components/AgAppBar.vue";
import AgNavDrawer from "@/components/AgNavDrawer.vue";

// El :key fuerza a recrear el componente al cambiar de ruta, para que las
// vistas Edit recarguen sus datos al pasar de un registro a otro.
const route = useRoute();
</script>
